const { userAgent, maxTouchPoints } = navigator;

export const getUserAgentValue = () => {
  const hasValueInUserAgent = (value) => userAgent.indexOf(value) !== -1;

  return {
    userAgent,
    isMobile: hasValueInUserAgent('Mobile'),
    isIOS:
      hasValueInUserAgent('iPhone') ||
      hasValueInUserAgent('iPad') ||
      (hasValueInUserAgent('Macintosh') && maxTouchPoints > 1), // safari + iPad
    isChromium: hasValueInUserAgent('Chrome'),
    isKakaoInApp: hasValueInUserAgent('KAKAOTALK'),
  };
};
